import React from 'react';

import { Headset } from '@hpi-sox/hpstellar-veneer-icons';
import { Cart, ChevronRight } from '@hpi-sox/hpstellar-vis-icons';
import { CategoryTile, Typography } from '@hpi-sox/hpstellar-core/visId';
import TypographyOld from '@hpi-sox/hpstellar-core/Typography';
import Button from '@hpi-sox/hpstellar-core/visId/Button';

import useSiteConfig from '../../hooks/useSiteConfig';

import './css/search-support-static-tiles.less';


const getStaticSupportTiles = siteConfig => {
    const variant = 'product';
    const { basename } = siteConfig || {};

    const btnProps = {
        // style: {
        //     fontWeight: 700,
        //     display: 'flex',
        //     alignItems: 'center',
        //     marginTop: '4px'
        // }
        className: 'srp-static-tile-view-button'
    }

    const descProps = {
        className: 'srp-static-tile-description'
    }

    const descriptionTypographyProps = {
        className: 'srp-support-static-description-container'
    };

    const orderStatusLink = `${basename}/MyAccountOrderStatusView`;
    const customerServiceLink = `${basename}/ContentView?eSpotName=CustomerService&catalogId=10051&langId=-1&storeId=10151`;
    return [
        {
            title: <TypographyOld variant='titleS' tag='p'>Your purchases</TypographyOld>,
            image:<Cart size='m' style={{backgroundColor: '#8EBDCE', display: 'inline'}} />,
            description: (
                <>
                    <Typography variant='caption' tag='p' {...descProps}>Are you looking for order status or shipping information?</Typography>
                    <Button to={orderStatusLink} theme='dark' variation='tertiary' {...btnProps}>View your purchases <ChevronRight size='s'/></Button>
                </>
            ),
            descriptionTypographyProps,
            variant,
            to: orderStatusLink ,
            className: 'srp-support-purchases-tile'
        },
        {
            title: <TypographyOld variant='titleS' tag='p'>Order support</TypographyOld>,
            image: (
                <Headset size={24} style={{backgroundColor: '#8FBAFF', transform: "scale(1.3, 1.3)"}} />
            ),
            description: (
                <>
                    <Typography variant='caption' tag='p' {...descProps} >Need help? Visit our support page or contact us</Typography>
                    <Button to={customerServiceLink} theme='dark' variation='tertiary' {...btnProps}>Visit order support <ChevronRight size='s'/></Button>
                </>
            ),
            descriptionTypographyProps,
            to: customerServiceLink,
            variant,
            className: 'srp-support-customer-tile'
        }
    ]
};

export default ({ className }) => {
    const siteConfig = useSiteConfig();
    const tiles = getStaticSupportTiles(siteConfig);
    return (
        <div className={`srp-default-support-tiles${className ? ' ' + className : ''}`}>
            {
                tiles.map((tile, idx) => (
                    <CategoryTile
                        key={idx}
                        imageWrapperClassName='srp-support-tile-image-wrapper'
                        {...tile}
                    />
                ))
            }
        </div>
    );
}